import React, {useCallback, useEffect, useState} from "react";
import Preaching from "../../components/preaching/Preaching";
import {deletePreaching, getPreaches} from "../../clients/PreachingClient";
import Loading from "../../components/loading/Loading";
import PaginationComponent from "../../components/pagination/Paginators";
import {useAuth} from "../../context/AuthContext";
import {PreachingContext} from "../../context/PreachingContext";
import CreateButton from "../../components/buttons/CreateButton";
import CreatePreachingForm from "../../components/forms/CreatePreachingForm";
import ConfirmDialog from "../../components/forms/ConfirmDialog";
import EditPreachingForm from "../../components/forms/EditPreachingForm";
import sendSuccessAlert, {sendErrorAlert} from "../../services/alertService";

const Preachings = () => {

    const [countItems, setCountItems] = useState(0);
    const [loading, setLoading] = useState(true);
    const [preachings, setPreachings] = useState([]);
    const [page, setPage] = useState(0);
    const size = 15;
    const {isUserAdmin} = useAuth();
    const [selectedPreaching, setSelectedPreaching] = useState(null);
    const [isOpenForm, setOpenForm] = useState(false);
    const [isOpenDelete, setOpenDelete] = useState(false);
    const [redacted, setRedacted] = useState(false);

    const handlePageClick = (event) => {
        setPage(event.selected);
    }

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const res = await getPreaches(page + 1, size);
                if (res?.data?.items) {
                    setPreachings(res.data.items);
                    setCountItems(res.data.count_items);
                } else {
                    setPreachings([]);
                }
            } catch (e) {
                console.error("Ошибка при загрузке проповедей:", e);
                setPreachings([]);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [page]);

    const refresh = useCallback(() => {
        getPreaches(page + 1, size)
            .then(res => {
                // не обнуляем список при сетевом сбое — иначе проповеди «пропадают»
                if (res?.data?.items) {
                    setPreachings(res.data.items);
                    setCountItems(res.data.count_items || 0);
                }
            })
            .catch((e) => console.error("Ошибка обновления списка проповедей:", e))
            .finally(() => setLoading(false));
    }, [page, size]);

    async function handleDeletePreaching() {
        const id = selectedPreaching?.id;
        try {
            await deletePreaching(id);
            setOpenDelete(false);
            sendSuccessAlert('Проповедь успешно удалена');
            await refresh();
        } catch (e) {
            console.error('Ошибка удаления проповеди:', e);
            sendErrorAlert('Не удалось удалить проповедь. Попробуйте ещё раз.');
        }
    }

    function openCreateForm() {
        setOpenForm(true);
    }

    return (
        <PreachingContext.Provider
            value={{
                selectedPreaching,
                setSelectedPreaching,
                isOpenForm,
                setOpenForm,
                isOpenDelete,
                setOpenDelete,
                redacted,
                setRedacted,
                refresh
            }}
        >
            <div className={`container`}>
                {loading ? <Loading/> :
                    <div>
                        <h2 className="text-center">Церковные проповеди</h2>
                        {isUserAdmin && (
                            <CreateButton text={`Добавить проповедь`}
                                          onClick={openCreateForm}/>
                        )}
                        <CreatePreachingForm/>
                        <EditPreachingForm/>
                        <ConfirmDialog
                            onSubmit={handleDeletePreaching}
                            isOpen={isOpenDelete}
                            text={`Вы действительно хотите удалить проповедь "${selectedPreaching?.theme}"?`}
                            onClose={() => setOpenDelete(false)
                            }/>
                        <div style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'flex-start',
                            justifyContent: 'center',
                            gap: '16px',
                            padding: '0 20px'
                        }}>

                            {preachings.map(el => (
                                <Preaching isUserAdmin={isUserAdmin} el={el} key={el.id}/>
                            ))}
                        </div>
                        {Math.ceil(countItems / size) <= 2 ? null :
                            <PaginationComponent size={size}
                                                 handlePageClick={handlePageClick}
                                                 countElements={countItems}
                                                 page={page}/>
                        }

                    </div>
                }
            </div>
        </PreachingContext.Provider>
    );
}

export default Preachings;